/* eslint-disable eqeqeq */
import R from 'ramda';
import objectRecord from './object_record';
import { ACTIONS } from '../const';
import { toID, switcher } from './utils';

const tagSet = R.compose(
    R.filter(t => t != ''),
    R.split('\n'),
    R.defaultTo('')
);

export const SectionRecord = objectRecord({
    id: null,
    class_number: null,
    content: null,
    course_title: null,
    course_catalog_number: null,
    course_subject: null,
    resource_uri: null,
    term_id: null,
    tags: [],
    instructor_names: null,
    // # pluralization is hard! let's go shopping.
    instructors: [],
});

function fromServer(data) {
    return new SectionRecord({
        ...data,
        term_id: toID(data.term),
        tags: tagSet(data.tags),
        instructors: data.instructor,
    });
}

export default switcher(
    {},
    {
        [ACTIONS.CREATE_COLLECTION](state, action) {
            const { section_id, name } = action.payload;
            const addTag = R.append(name);

            return R.over(R.lensPath([section_id, 'tags']), addTag, state);
        },

        [ACTIONS.DELETE_COLLECTION](state, action) {
            const { section_id, name } = action.payload;
            const removeTag = R.filter(t => t != name);

            return R.over(R.lensPath([section_id, 'tags']), removeTag, state);
        },

        [ACTIONS.SYNC_SECTION](state, action) {
            const { section } = action;

            return {
                ...state,
                [section.id]: fromServer(section),
            };
        },
    }
);



// WEBPACK FOOTER //
// ./src/reducers/section.js